import React, { useEffect, useRef, useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { clearUser } from "../../Redux/authSlice";
import {
  selectDisplayName,
  selectEmail,
  selectAvatar,
  selectInitials,
} from "../../Redux/authSlice";
import { ReactSVG } from "react-svg";
import ManageSubscription from "../../Asset/Manage Subscription.svg";
import gradientArrow from "../../Asset/gradient arrow.svg";
import { FiLogOut } from "react-icons/fi";
import { BsTriangleFill } from "react-icons/bs";
import axios from "axios";
import { toast } from "react-toastify";
import sideBarLogo from "../../Asset/ZT-Sidebar-logo.svg";
import { SiCircle } from "react-icons/si";


const Profile = () => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  // Normalized values from Redux
  const name = useSelector(selectDisplayName);
  const email = useSelector(selectEmail);
  const avatar = useSelector(selectAvatar);
  const initials = useSelector(selectInitials);

  useEffect(() => {
    const onDown = (e) => {
      if (!dropdownRef.current) return;
      if (!dropdownRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, []);

  const handleLogout = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}api/auth/logout`,
        {},
        { withCredentials: true }
      );
      if (response?.data?.success) {
        toast.success(response.data?.message);
        dispatch(clearUser());
        navigate("/");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Logout failed"
      );
    }
  };

  const goToSettings = () => {
    setOpen(false);
    navigate("/settings");
  };

  return (
    <div className="flex items-center md:gap-3 gap-2" ref={dropdownRef}>
      <div className="relative">
        <IoIosArrowDown
          className="text-[#00000042] cursor-pointer"
          onMouseDown={() => setOpen((v) => !v)}
          aria-label="Open account menu"
        />

        {open && (
          <div
            className="absolute -right-7 top-6 z-30 md:w-[22rem] w-[17rem] md:p-3 p-2 origin-top-right rounded-3xl bg-white shadow-lg"
            role="menu"
          >
            <BsTriangleFill className="absolute right-6 -top-3 md:size-6 size-5 text-white" />

            {/* Account tab (avatar + name + email) */}
            <div className="flex items-center md:gap-3 gap-2 md:p-3 p-2 md:rounded-2xl rounded-lg bg-[#F7F7F8]">
              {avatar ? (
                <img
                  src={avatar}
                  alt="Profile"
                  className="md:h-12 h-10 md:w-12 w-10 rounded-full object-cover"
                  referrerPolicy="no-referrer"
                />
              ) : (
                <div className="md:h-12 h-10 md:w-12 w-10 rounded-full bg-[#EDF2F7] text-[#353535] grid place-items-center font-semibold">
                  {initials || "U"}
                </div>
              )}

              <div className="min-w-0">
                <div className="truncate md:text-base text-sm font-bold text-[#353535]">
                  {name || "Account"}
                </div>
                <div
                  className="truncate md:text-sm text-xs text-[#3535359E]"
                  title={email}
                >
                  {email || "—"}
                </div>
              </div>
            </div>

            <div className="mt-2 flex flex-col items-start gap-2 p-1 text-sm font-medium">
              {/* Web app */}

              <NavLink
                to={"/app"}
                onClick={() => setOpen(false)}
                className="flex w-full items-center justify-between gap-2 rounded-xl p-2 hover:bg-[#F7F7F8]"
                role="menuitem"
              >
                <div className="flex items-center gap-3">
                  <ReactSVG
                    src={sideBarLogo}
                    beforeInjection={(svg) => {
                      svg.setAttribute("class", "md:w-7 w-6 md:h-7 h-6");
                    }}
                    className="w-auto"
                  />
                  <div className="flex flex-col font-inter">
                    <span className="md:text-lg text-sm font-semibold text-[#353535]">
                      Web App
                    </span>
                    <span className="text-xs text-[#3535359E]">
                      Access the Zero Tying app!
                    </span>
                  </div>
                </div>
                <div className="pt-1">
                  <ReactSVG
                    src={gradientArrow}
                    beforeInjection={(svg) => {
                      svg.setAttribute("class", "h-4 w-auto");
                    }}
                    className="w-auto"
                  />
                </div>
              </NavLink>

              {/* Manage Subscription link */}


              <NavLink
                to={"/settings"}
                onClick={() => setOpen(false)}
                className="flex w-full items-center justify-between gap-2 rounded-xl p-2 hover:bg-[#F7F7F8]"
                role="menuitem"
              >
                <div className="flex items-center gap-3">
                  <ReactSVG
                    src={ManageSubscription}
                    beforeInjection={(svg) => {
                      svg.setAttribute("class", "md:w-7 w-6 md:h-7 h-6");
                    }}
                    className="w-auto"
                  />
                  <div className="flex flex-col font-inter">
                    <span className="md:text-lg text-sm font-semibold text-[#353535]">
                      Manage Subscription
                    </span>
                    <span className="text-xs text-[#3535359E]">
                      Access billing and plan settings
                    </span>
                  </div>
                </div>
                <div className="pt-1">
                  <ReactSVG
                    src={gradientArrow}
                    beforeInjection={(svg) => {
                      svg.setAttribute("class", "h-4 w-auto");
                    }}
                    className="w-auto"
                  />
                </div>
              </NavLink>


              {/* Usage */}


              <NavLink
                to={"/usage"}
                onClick={() => setOpen(false)}
                className="flex w-full items-center justify-between gap-2 rounded-xl p-2 hover:bg-[#F7F7F8]"
                role="menuitem"
              >
                <div className="flex items-center gap-3">
                  {/* <ReactSVG
                    src={ManageSubscription}
                    beforeInjection={(svg) => {
                      svg.setAttribute("class", "md:w-7 w-6 md:h-7 h-6");
                    }}
                    className="w-auto"
                  /> */}
                  <SiCircle size={26} />
                  <div className="flex flex-col font-inter">
                    <span className="md:text-lg text-sm font-semibold text-[#353535]">
                      Usage
                    </span>
                    <span className="text-xs text-[#3535359E]">
                      Track your plan usage and remaining limits
                    </span>
                  </div>
                </div>
                <div className="pt-1">
                  <ReactSVG
                    src={gradientArrow}
                    beforeInjection={(svg) => {
                      svg.setAttribute("class", "h-4 w-auto");
                    }}
                    className="w-auto"
                  />

                </div>
              </NavLink>


              {/* Divider */}
              <p className="my-1 w-full border-t border-[#0000001A]" />

              {/* Logout */}
              <button
                onClick={handleLogout}
                className="flex w-full items-center md:gap-3 gap-2 rounded-xl p-2 md:text-xl text-base font-semibold text-[#353535] hover:bg-[#F7F7F8]"
                role="menuitem"
              >
                <FiLogOut className="md:size-6 size-5 text-[#353535]" />
                Logout
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Top-bar avatar (CLICKABLE -> /settings) */}
      {avatar ? (
        <img
          src={avatar}
          className="xl:h-[2.975rem] lg:w-[2.5rem] w-[2.2rem] xl:w-[2.975rem] lg:h-[2.5rem] h-[2.2rem] rounded-full object-cover cursor-pointer"
          alt="profile"
          referrerPolicy="no-referrer"
          onClick={goToSettings}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") goToSettings();
          }}
        />
      ) : (
        <div
          className="xl:h-[2.975rem] lg:w-[2.5rem] w-[2.2rem] xl:w-[2.975rem] lg:h-[2.5rem] h-[2.2rem] rounded-full bg-[#EDF2F7] text-[#353535] grid place-items-center font-semibold cursor-pointer"
          onClick={goToSettings}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") goToSettings();
          }}
        >
          {initials || "U"}
        </div>
      )}
    </div>
  );
};

export default Profile;
